import { InjectionToken } from '@angular/core';

export const RESOURCE_URL = new InjectionToken<string>('RESOURCE_URL');
